import { createContext, useContext, useState, ReactNode } from 'react'

import { Filter } from 'cat-shared/utils'
import { FormName } from 'client/utils'

type TPageStateContext = {
  authForm: FormName
  setAuthForm: (form: FormName) => void
  listActiveQuestionId: string | null
  setListActiveQuestionId: (id: string | null) => void
  redirectQuestionId: string
  setRedirectQuestionId: (url: string) => void
  settingsPageState: SettingsPageState
  setSettingsPageState: (state: SettingsPageState) => void
  browseQuestionsPageState: BrowseQuestionsPageState
  setBrowseQuestionsPageState: (
    state: (state: BrowseQuestionsPageState) => BrowseQuestionsPageState
  ) => void
  isSubmitQuestionFormDirty: boolean
  setIsSubmitQuestionFormDirty: (isDirty: boolean) => void
  randomizerCategory: string
  setRandomizerCategory: (category: string) => void
  showQuestionVoteStats: boolean
  toggleQuestionVoteStats: (show: boolean) => void
}

const PageStateContext = createContext<TPageStateContext>({} as TPageStateContext)

type Props = {
  children: ReactNode
}

type SettingsPageState = {
  tabNo: number
}

type BrowseQuestionsPageState = {
  pageNo: number
  filter: Filter
  category: string
  search: string
}

export const PageStateContextProvider = ({ children }: Props) => {
  const [authForm, setAuthForm] = useState<FormName>(FormName.AuthenticationForm)
  const [listActiveQuestionId, setListActiveQuestionId] = useState<string | null>(null)
  const [redirectQuestionId, setRedirectQuestionId] = useState<string | null>(null)
  const [settingsPageState, setSettingsPageState] = useState<SettingsPageState>({
    tabNo: 1,
  })

  const [browseQuestionsPageState, setBrowseQuestionsPageState] =
    useState<BrowseQuestionsPageState>({
      pageNo: 1,
      filter: Filter.Answered,
      category: 'any',
      search: '',
    })

  const [isSubmitQuestionFormDirty, setIsSubmitQuestionFormDirty] =
    useState<boolean>(false)

  const [randomizerCategory, setRandomizerCategory] = useState<string>('any')
  const [showQuestionVoteStats, toggleQuestionVoteStats] = useState<boolean>(false)

  return (
    <PageStateContext.Provider
      value={{
        authForm,
        setAuthForm,
        listActiveQuestionId,
        setListActiveQuestionId,
        redirectQuestionId,
        setRedirectQuestionId,
        settingsPageState,
        setSettingsPageState,
        browseQuestionsPageState,
        setBrowseQuestionsPageState,
        isSubmitQuestionFormDirty,
        setIsSubmitQuestionFormDirty,
        randomizerCategory,
        setRandomizerCategory,
        showQuestionVoteStats,
        toggleQuestionVoteStats,
      }}
    >
      {children}
    </PageStateContext.Provider>
  )
}

export const usePageStateContext = () => {
  return useContext(PageStateContext)
}
